import { ElementVisible } from './element-visible';
var arr = new Map();
export default {
  install: function install(vue) {
    vue.directive('visible', {
      inserted: function inserted(el, binding) {
        var _ref = binding.value || {},
            visible = _ref.visible,
            invisible = _ref.invisible;

        var ev = new ElementVisible({
          el: el,
          visible: visible,
          invisible: invisible
        });
        ev.bind();
        arr.set(el, ev);
      },
      unbind: function unbind(el, binding) {
        var ev = arr.get(el);
        ev === null || ev === void 0 ? void 0 : ev.unbind();
        arr["delete"](el);
      }
    });
  }
};